import Vue from 'vue'
import VueI18n from 'vue-i18n'
import * as de_messages from './translations/de.json'
import * as en_messages from './translations/en.json'

Vue.use(VueI18n);

function getLanguageURLParameter() {
    let query = window.location.search.substring(1);
    let pairs = query.split('&');

    for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i].split('=');
        if(pair[0] === 'language') {
            if(pair[1].length > 0)
                return pair[1];
        }
    }

    return 'de';
}

export default new VueI18n({
    locale: getLanguageURLParameter(),
    fallbackLocale: 'de',
    messages: {
        en: {...en_messages.default},
        de: {...de_messages.default}
    }
})